import 'array.prototype.tosorted/shim';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import './bones/registry';
import './styles.css';

import { Stack } from '@/components/stack';
import {
  appQueryClient,
  Provider as TanstackProvider,
} from '@/integrations/tanstack-query/root-provider';
import { FAILED_FETCH_DYNAMICALLY_IMPORT_MODULE } from './consts/error-messages';
import i18n from './integrations/react-i18next/i18n';
import { sentryRootOptions } from './integrations/sentry/root-options';
import { router } from './integrations/tanstack-router/router';
import RouterAlert, {
  type RouterAlertProps,
} from './integrations/tanstack-router/router-error-component';
import reportWebVitals from './report-web-vitals';

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

import('./integrations/sentry/sentry');

const rootElement = document.getElementById('app');

if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement, sentryRootOptions);

  root.render(
    <StrictMode>
      <I18nextProvider i18n={i18n}>
        <TanstackProvider queryClient={appQueryClient}>
          <RouterProvider
            defaultErrorComponent={({ error, reset }) => {
              const err: Error =
                error instanceof Error ? error : new Error('unknown error');
              const alertProps: RouterAlertProps =
                import.meta.env.PROD &&
                err.message.includes(FAILED_FETCH_DYNAMICALLY_IMPORT_MODULE)
                  ? { kind: 'newVersion' }
                  : { kind: 'error', onClick: reset, error: err };

              return (
                <Stack align="center" className="w-full" justify="center">
                  <RouterAlert {...alertProps} />
                </Stack>
              );
            }}
            router={router}
          />
        </TanstackProvider>
      </I18nextProvider>
    </StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
